module.exports = __webpack_public_path__ + "static/media/facebook-white.3ab2bb69.svg";